import React, { useState } from 'react';
import { Search, Briefcase, ChevronRight, Users, Award, Globe } from 'lucide-react';

export default function JobApplicationPage() {
  const [activeCategory, setActiveCategory] = useState('all');
  
  const jobCategories = [
    { id: 'all', name: 'All Positions' },
    { id: 'dev', name: 'Development' },
    { id: 'design', name: 'Design' },
    { id: 'pm', name: 'Project Management' },
    { id: 'qa', name: 'QA & Testing' }
  ];
  
  const jobListings = [
    { 
      id: 1, 
      title: 'Unreal C Coder', 
      category: 'Volunteer dev', 
      location: 'Remote', 
      type: 'part-time',
      posted: 'may 11th'
    },
    { 
        id: 2, 
        title: 'API programer', 
        category: 'Volunteer dev', 
        location: 'Remote', 
        type: 'part-time',
        posted: 'may 11th'
      },
  ];
  
  const filteredJobs = activeCategory === 'all' 
    ? jobListings 
    : jobListings.filter(job => job.category === activeCategory);

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-indigo-900 text-white">
        <div className="max-w-6xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl font-extrabold sm:text-5xl md:text-6xl">
              Join the 4FingerStudios Team
            </h1>
            <p className="mt-4 text-xl text-indigo-100 max-w-3xl mx-auto">
              Create the next generation of gaming experiences
            </p>
            <div className="mt-8 flex justify-center">
              <a 
                href="#open-positions" 
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-900 bg-white hover:bg-indigo-50"
              >
                View Open Positions
                <ChevronRight className="ml-2 h-5 w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
      

      {/* Job Listings Section */}
      <div id="open-positions" className="max-w-6xl mx-auto px-4 py-12 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900">Open Positions</h2>
          <p className="mt-4 text-lg text-gray-600">
            Find your perfect role and help shape the future of gaming
          </p>
        </div>
        
        {/* Search & Filter */}
        <div className="mb-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="relative w-full md:w-64">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <Search className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                placeholder="Search positions..."
              />
            </div>
            
            <div className="flex space-x-2 overflow-x-auto w-full md:w-auto">
              {jobCategories.map(category => (
                <button
                  key={category.id}
                  onClick={() => setActiveCategory(category.id)}
                  className={`px-4 py-2 rounded-md text-sm font-medium ${
                    activeCategory === category.id
                      ? 'bg-indigo-600 text-white'
                      : 'bg-white text-gray-700 hover:bg-gray-100'
                  }`}
                >
                  {category.name}
                </button>
              ))}
            </div>
          </div>
        </div>
        
        {/* Job Listings */}
        <div className="space-y-4">
          {filteredJobs.map(job => (
            <div key={job.id} className="bg-white shadow overflow-hidden sm:rounded-md">
              <div className="px-4 py-5 sm:px-6">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="text-lg leading-6 font-medium text-gray-900">{job.title}</h3>
                    <div className="mt-2 flex items-center text-sm text-gray-500">
                      <Briefcase className="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" />
                      <p>{job.type} • {job.location}</p>
                    </div>
                    <p className="mt-1 text-xs text-gray-500">Posted {job.posted}</p>
                  </div>
                  <div>
                    <a
                      href={`/apply/${job.id}`}
                      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700"
                    >
                      Apply Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        
        {filteredJobs.length === 0 && (
          <div className="text-center py-12">
            <p className="text-gray-500">No positions found. Please try another category.</p>
          </div>
        )}
      </div>
      
      {/* CTA Section */}
      <div className="bg-indigo-700 text-white">
        <div className="max-w-6xl mx-auto px-4 py-12 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-extrabold">Don't see the right position?</h2>
          <p className="mt-4 text-xl text-indigo-100 max-w-3xl mx-auto">
            We're always looking for talented individuals to join our team. Send us your resume and we'll keep it on file.
          </p>
          <div className="mt-8">
            <a 
              href="/general-application" 
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-white hover:bg-indigo-50"
            >
              Submit General Application
            </a>
          </div>
        </div>
      </div>
      
      {/* Footer */}
      <footer className="bg-gray-800 text-white">
        <div className="max-w-6xl mx-auto px-4 py-8 sm:px-6 lg:px-8">
          <div className="md:flex md:items-center md:justify-between">
            <div className="flex justify-center md:justify-start">
              <h2 className="text-2xl font-bold">4FingerStudios</h2>
            </div>
            <div className="mt-8 md:mt-0">
              <div className="flex justify-center md:justify-end space-x-6">
                <a href="https://4fingerstudios.com/" className="text-gray-400 hover:text-white">
                  About Us
                </a>
                <a href="https://4fingerstudios.com/Privacy" className="text-gray-400 hover:text-white">
                  Privacy Policy
                </a>
              </div>
            </div>
          </div>
          <div className="mt-8 border-t border-gray-700 pt-8 text-center md:text-left">
            <p className="text-base text-gray-400">
              &copy; 2025 4FingerStudios. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}